/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexamplebrightenprompt3Inputs */

const en_refineexamplebrightenprompt3 = /** @type {(inputs: Refineexamplebrightenprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brighten the image and make the colors richer`)
};

const de_refineexamplebrightenprompt3 = /** @type {(inputs: Refineexamplebrightenprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helle das Bild auf und mache die Farben kräftiger`)
};

/**
* | output |
* | --- |
* | "Brighten the image and make the colors richer" |
*
* @param {Refineexamplebrightenprompt3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexamplebrightenprompt3 = /** @type {((inputs?: Refineexamplebrightenprompt3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexamplebrightenprompt3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexamplebrightenprompt3(inputs)
	return de_refineexamplebrightenprompt3(inputs)
});
export { refineexamplebrightenprompt3 as "refineExampleBrightenPrompt" }